import { DropDownList } from '@progress/kendo-react-dropdowns'
import capitalize from 'lodash/capitalize'
import toPairs from 'lodash/fp/toPairs'
import split from 'lodash/split'
import without from 'lodash/without'
import * as React from 'react'
import { connect } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import Redux from 'redux'
import * as RasaInput from '../../../components/rasa-input'
import * as NewsbriefTypes from '../types'
import * as NewsbriefUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'
import * as Types from './types'

interface DispatchProps {
  createIcon: NewsbriefTypes.StateAddActionCreator,
  deleteIcon: NewsbriefTypes.StateDeleteActionCreator,
  selectedPartner: string,
  updateDropdown: NewsbriefTypes.StateUpdateActionCreator,
  updateUrl: NewsbriefTypes.StateUpdateActionCreator,
}
interface WrappedState {
  dispatch: Redux.Dispatch<Redux.Action>,
}
type Props = WrappedState & DispatchProps & NewsbriefTypes.WrappedConfigurationRows

const SocialMedia =
  ({rows, dispatch, createIcon, deleteIcon, selectedPartner, updateUrl, updateDropdown}: Props) => {

  const takenItems = rows.filter((item: NewsbriefTypes.ConfigurationRow) => !item.editing.isSyntheticRow)
                         .map((item: NewsbriefTypes.ConfigurationRow) => item.data.key)
  const availableItems = Constants.socialMediaKeys
    .filter((item: Types.SocialMediaKey) => !takenItems.includes(item.key))

  return (
    <div>
      {availableItems.length > 0 && rows.length < 5 &&
       <Button className="add-color"
               title="Add social media icon."
               onClick={(e: any) => dispatch(createIcon(selectedPartner))}>
                ADD ICON
       </Button>}
      <Row>
        {rows.map((row: NewsbriefTypes.ConfigurationRow, idx: number) => {
          const iconType = split(row.data.key, '_')[0]
          const icon = {
            ...row.data,
            displayName: capitalize(iconType),
            iconType,
          }
          return <Col key={icon.key + idx} sm={{ size: 4, offset: 1 }}>
              <div className="social-media-container">
                 {icon.iconType &&
                 <img src={`${Constants.IMAGE_SERVER_RESOURCE}/social-media/${icon.iconType}_64_black_square.png`}
                      height="32"
                      width="32" />}
                 <DropDownList className="dropdown-override width-75"
                      data={!row.editing.isSyntheticRow ? [icon] :
                         Constants.socialMediaKeys.filter((item: Types.SocialMediaKey) => {
                          const iconsToExclude = without(takenItems, icon.key)
                          return !iconsToExclude.includes(item.key)})}
                      onChange={(e) => dispatch(updateDropdown({
                        name: row.data.key,
                        property: 'key',
                        rowId: row.rowId,
                        value: e.target.value.key,
                      }))}
                      textField={'displayName'}
                      dataItemKey={'key'}
                      value={icon} />
                <i className="delete-icon k-icon k-i-minus-circle icon-24 icon-red"
                  onClick={() => dispatch(deleteIcon(row.rowId))}/>
                <RasaInput.RasaInput label="Social Media URL"
                                    placeholder="Enter a valid URL."
                                    validation={RasaInput.validateUrl(icon.value)}
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                      dispatch(updateUrl({
                                        name: row.data.key,
                                        property: 'value',
                                        rowId: row.rowId,
                                        value: e.target.value,
                                      }))}
                                    value={icon.value} />
              </div>
            </Col>
        })}
      </Row>
    </div>
  )
}

export const SocialMediaConnected = connect(
  ({ newsbriefConfigs }: NewsbriefTypes.WrappedState) =>
  ({
    rows:
      toPairs(newsbriefConfigs.socialMedia)
        .map(([rowId, {data, editing}]: [string, NewsbriefTypes.Row<NewsbriefTypes.PayloadData>]) =>
          ({rowId, data, editing}))
        .filter(({rowId, data, editing}) =>
          !data.isDefault && data.is_active &&
          NewsbriefUtils.isSelectedPartner(data.partner_code, newsbriefConfigs.configState.selectedPartner)),
    selectedPartner: newsbriefConfigs.configState.selectedPartner,
  }),
  (dispatch) => ({
    createIcon: Actions.addIcon,
    deleteIcon: Actions.deleteIcon,
    dispatch,
    updateDropdown: Actions.handleDropdown,
    updateUrl: Actions.handleUrlChange,
  }),
)(SocialMedia)



// WEBPACK FOOTER //
// ./src/pages/newsbrief/social-media/component.tsx